<input [formControlName]="question.key"
       [ngClass]="{'is-invalid': !isValid}"
       class="form-check-input"
       type="checkbox"
       [id]="question.key"
       [required]="question.required"
>
